import R from "ramda";
import { http } from "./http";

export const fetchReports = (accountId, limit = 25) => (
  http.get(`/accounts/${accountId}/exports?limit=${limit}`)
    .then(response => {
      const reports = R.pathOr([], ["data", "exports"], response);
      return { response, reports };
    })
);

export const submitReport = (accountId, report) => (
  http.post(`accounts/${accountId}/exports`, report)
);



// WEBPACK FOOTER //
// ./src/js/api/reports.js